import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { Category } from 'app/types/catalogue/category'
import { Client } from 'app/types/park/client'

/** Categories list returned by the API. */
export const CategoryProduct = Category.extend({
    client: Client,
})

export type CategoryProduct = z.infer<typeof CategoryProduct>

/** Data returned for allergens, categories, subcategories.  */
export const CategoryProductRequest = Pagination.extend({
    results: CategoryProduct.array(),
})

export type CategoryProductRequest = z.infer<typeof CategoryProductRequest>
